import React from 'react';
import './language.scss';
import { toggleLocaleHandler, getAllLocaleUtils } from '../../../../hooks/i18n-hook';
import flag_us from '../../../../asset/images/united-states.png';
import flag_ja from '../../../../asset/images/japan.png';

var Language = function Language(_ref) {
  var place = _ref.place,
      path = _ref.path;

  var _getAllLocaleUtils = getAllLocaleUtils(),
      i18n = _getAllLocaleUtils.i18n,
      locale = _getAllLocaleUtils.locale;

  return /*#__PURE__*/React.createElement("ul", {
    className: "language language--" + place
  }, locale === 'en' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return toggleLocaleHandler(i18n, locale, path);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: flag_ja,
    alt: "japan"
  }))), locale === 'ja' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return toggleLocaleHandler(i18n, locale, path);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: flag_us,
    alt: "usa"
  }))));
};

export default Language;